<div class="global-search-list-wrapper">
  <div class="search-list-header">
    <h2 *ngIf="searchQuery">Search Results for "{{ searchQuery }}"</h2>
    <div *ngIf="searchResults" class="results-summary">
      <span class="total-count">{{ searchResults.totalCount }} results found</span>
      <span *ngIf="searchResults.totalPages > 1" class="page-info">
        Page {{ currentPage }} of {{ searchResults.totalPages }}
      </span>
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <p>Loading results...</p>
  </div>

  <div *ngIf="!isLoading && searchResults && searchResults.results.length > 0" class="search-results-container">
    <div class="search-results-list">
      <div
        *ngFor="let result of searchResults.results"
        class="search-result-item"
        (click)="onResultClick(result)"
      >
        <div class="result-icon">
          <i *ngIf="result.type === 'Customer'" class="fas fa-user"></i>
          <i *ngIf="result.type === 'Quote'" class="fas fa-file-invoice"></i>
        </div>

        <div class="result-content">
          <div class="result-title" [innerHTML]="getHighlightedTitle(result)"></div>
          <div class="result-subtitle">{{ result.subtitle }}</div>

          <div class="result-highlights">
            <span
              *ngFor="let field of getDisplayFields(result)"
              class="highlight-field"
              [class.matched]="field.isMatched"
            >
              <strong>{{ field.fieldName }}:</strong>
              <span [innerHTML]="field.highlightedValue"></span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="searchResults.totalPages > 1" class="pagination-container">
      <button
        class="pagination-btn"
        [disabled]="!hasPreviousPage()"
        (click)="onPageChange(currentPage - 1)"
      >
        Previous
      </button>

      <div class="page-numbers">
        <button
          *ngFor="let page of getPageNumbers()"
          class="page-number"
          [class.active]="page === currentPage"
          [class.ellipsis]="page === -1"
          [disabled]="page === -1 || page === currentPage"
          (click)="page !== -1 && page !== currentPage && onPageChange(page)"
        >
          {{ page === -1 ? '...' : page }}
        </button>
      </div>

      <button
        class="pagination-btn"
        [disabled]="!hasNextPage()"
        (click)="onPageChange(currentPage + 1)"
      >
        Next
      </button>
    </div>
  </div>

  <div *ngIf="!isLoading && searchResults && searchResults.results.length === 0" class="no-results">
    <p>No results found for "{{ searchQuery }}"</p>
    <p class="no-results-hint">Try adjusting your search terms or check for typos.</p>
  </div>

  <div *ngIf="!isLoading && !searchQuery" class="no-query">
    <p>Enter a search query to see results</p>
  </div>
</div>

